import { WidgetV8MappingResponseItem } from '@/api-client/metav8Over/model';
import { GRID_LAYOUT_OPTION_MULTIPLIER } from '@/dashboard/features/dashboardLayout/domain/baseGridLayout.constants';
import { DisplayStyleType, WidgetChartType } from '@/dashboard/shared/types/widgets.types';

/**
 * 대시보드 위젯 좌표 변환
 * @param gridLayoutOption - 그리드 레이아웃 옵션
 */
export const convertDashboardWidgetsCoordinates = (
  gridLayoutOption: WidgetV8MappingResponseItem,
) => {
  return {
    ...gridLayoutOption,
    widgets: gridLayoutOption.widgets?.map((widget) =>
      widget.map((item) => ({
        ...item,
        x: (item.x ?? 0) * GRID_LAYOUT_OPTION_MULTIPLIER,
        y: (item.y ?? 0) * GRID_LAYOUT_OPTION_MULTIPLIER,
        width: (item.width ?? 0) * GRID_LAYOUT_OPTION_MULTIPLIER,
        height: (item.height ?? 0) * GRID_LAYOUT_OPTION_MULTIPLIER,
      })),
    ),
  };
};

/**
 * 차트 타입에 맞는 호환 가능한 displayStyle 반환
 * @param chartType - 차트 타입
 */
export const getCompatibleDisplayStyle = (chartType: WidgetChartType): DisplayStyleType => {
  switch (chartType) {
    case 'EQUALIZER':
      return 'EQUALIZER_ENTRY';
    default:
      return '';
  }
};
